export default __webpack_public_path__ + "static/media/2.de9ca3db.jpg";